import { useState } from 'react';

const EditNotesTextArea = ({currentEncounter, setCurrentEncounter, socket}) => {
    const [notes, setNotes] = useState(currentEncounter.notes || '')

    const validate = (e) => {
        setNotes(e.target.value)
    }

    const sendUpdate = () => {
        if (currentEncounter.notes !== notes) {
            const updatedEncounter = {
                ...currentEncounter,
                notes: notes
            }
            setCurrentEncounter(updatedEncounter);
            socket.emit('updateEncounterNotes', notes, updatedEncounter.encounterGuid);
        }
    }

    return (
        <div className='editHpGrow'>
            <div className="notesWidgetFlag"/>
            <div className="notesContainer">
                <div className="editBlockTitle">Encounter Notes - <i>{currentEncounter.encounterName}</i></div>
                <hr className="editlineSeperator"/>
                <textarea
                    className="editNotesInput"
                    type="text"
                    value={notes}
                    onChange={(e) => validate(e)} 
                    onBlur={(e) => sendUpdate()} 
                />  
            </div>
        </div>
    )
}

export default EditNotesTextArea;